import { render, staticRenderFns } from "./SearchContact.vue?vue&type=template&id=2550dbba&"
import script from "./SearchContact.vue?vue&type=script&lang=js&"
export * from "./SearchContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports